import React from 'react';
// import Select from 'rc-select';
import PaginaTion from 'rc-pagination';
// import 'rc-pagination/assets/index.css';
import 'rc-pagination/dist/rc-pagination.min.css';
import 'rc-select/assets/index.css';

import css from './Pagination.css';

const Pagination = props => {
  const {
    defaultPageSize,
    defaultCurrent,
    current,
    onShowSizeChange,
    onChange,
    total,
  } = props;
  return (
    <div className={css.pagination}>
      <PaginaTion
        // selectComponentClass={Select}
        showQuickJumper
        showSizeChanger
        defaultPageSize={defaultPageSize || 20}
        defaultCurrent={defaultCurrent || 1}
        current={current || 1}
        onShowSizeChange={onShowSizeChange}
        onChange={onChange}
        total={total || 450}
      />
    </div>
  );
};

export default Pagination;
